<div class="legend-box general-box clearfix">
  <span class="icon-close" (click)="closeLegend()"></span>
  <div class="item-box">
    <h2 class="h-special">{{ 'LEGEND' | translate }}</h2>
    <ul class="list-note">
      <li>{{ '• The numbers displayed on the markers indicate the amount of surveys made by the users in the same place.' | translate }}</li>
      <li>{{ '• The colors of the markers refer to the noise levels calculated by the app in dB(A). They correspond to:' | translate }}</li>
    </ul>
  </div>
  <div class="item-box">
    <h2 class="h-special">{{ 'NOISE LEVELS' | translate }}</h2>
    <ul class="list-legend clearfix">
      <li class="legend01">20-35</li>
      <li class="legend06">55-60</li>
      <li class="legend02">35-40</li>
      <li class="legend07">60-65</li>
      <li class="legend03">40-45</li>
      <li class="legend08">65-70</li>
      <li class="legend04">45-50</li>
      <li class="legend09">70-75</li>
      <li class="legend05">50-55</li>
      <li class="legend10">>75</li>
    </ul>
  </div>
</div>